// Messages for portal/Shipments (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.shipments.head': 'Shipments — Portal',
  'portal.shipments.title': 'Shipments',
  'portal.shipments.count_one': '{count} shipment',
  'portal.shipments.count_other': '{count} shipments',
  'portal.shipments.search.aria': 'Search shipments',
  'portal.shipments.search.placeholder': 'Search HBL, ref, PO…',
  'portal.shipments.filter_status': 'Filter by status',
  'portal.shipments.all_statuses': 'All statuses',
  'portal.shipments.mode.all': 'All',
  'portal.shipments.mode.ocean': 'Ocean',
  'portal.shipments.mode.air': 'Air',
  'portal.shipments.mode.truck': 'Truck',
  'portal.shipments.col.hbl_carrier': 'HBL / Carrier',
  'portal.shipments.col.route_status': 'Route & Status',
  'portal.shipments.col.eta': 'ETA',
  'portal.shipments.empty': 'No shipments match these filters.',
  'portal.shipments.load_more': 'Load more',
  'portal.shipments.loading': 'Loading…',
}

export const zhTW = {
  'portal.shipments.head': '貨件 — 客戶入口',
  'portal.shipments.title': '貨件',
  'portal.shipments.count_one': '{count} 筆貨件',
  'portal.shipments.count_other': '{count} 筆貨件',
  'portal.shipments.search.aria': '搜尋貨件',
  'portal.shipments.search.placeholder': '搜尋 HBL、參考號、PO…',
  'portal.shipments.filter_status': '依狀態篩選',
  'portal.shipments.all_statuses': '所有狀態',
  'portal.shipments.mode.all': '全部',
  'portal.shipments.mode.ocean': '海運',
  'portal.shipments.mode.air': '空運',
  'portal.shipments.mode.truck': '陸運',
  'portal.shipments.col.hbl_carrier': 'HBL / 承運商',
  'portal.shipments.col.route_status': '路線與狀態',
  'portal.shipments.col.eta': '預計到達',
  'portal.shipments.empty': '沒有符合篩選條件的貨件。',
  'portal.shipments.load_more': '載入更多',
  'portal.shipments.loading': '載入中…',
}
